import { API_URL, JWT_AUTH_ENDPOINT, PASSWORD_AUTH_ENDPOINT } from 'qap/constants'
import { requestActions } from 'state/request'
import { failure, success } from 'utilities/actions'
import { decamelizeKeys } from 'utilities/humps'

export const API_SESSION_PASSWORD_AUTH_CREATE = 'API_SESSION_PASSWORD_AUTH_CREATE'
export const API_SESSION_JWT_AUTH_CREATE = 'API_SESSION_JWT_AUTH_CREATE'
export const CLEAN_STORE_STATE = 'CLEAN_STORE_STATE'
export const LOGOUT_USER = 'LOGOUT_USER'
export const AUTH_EXPIRE_SESSION = 'AUTH_EXPIRE_SESSION'
export const AUTH_SESSION_REFRESH_SCHEDULED = 'AUTH_SESSION_REFRESH_SCHEDULED'
export const API_SESSION_FETCH = 'API_SESSION_FETCH'
export const API_SESSION_REFRESH = 'API_SESSION_REFRESH'
export const INITIALIZE_LOGIN = 'INITIALIZE_LOGIN'
export const API_SESSION_CLIENT_SETTINGS_UPDATE = 'API_SESSION_CLIENT_SETTINGS_UPDATE'
export const QUEUE_CLIENT_SETTINGS_UPDATE = 'QUEUE_CLIENT_SETTINGS_UPDATE'
export const SET_LOCAL_CLIENT_SETTINGS = 'SET_LOCAL_CLIENT_SETTINGS'

type passwordAuthData = {
  email: string;
  password: string;
  otpCode?: string;
};
type ClientSetting = {
  key: string;
  value: any;
};

export const passwordAuth = (data: passwordAuthData, redirect: any | null | undefined | string | null | undefined) => {
  return {
    type: requestActions.UNAUTHED_REQUEST,
    method: 'POST',
    url: `${API_URL}/${PASSWORD_AUTH_ENDPOINT}`,
    successAction: success(API_SESSION_PASSWORD_AUTH_CREATE),
    failureAction: failure(API_SESSION_PASSWORD_AUTH_CREATE),
    body: { data: decamelizeKeys({ ...data}) },
    redirect
  }
}

export const jwtAuth = (data: {
  token: string;
}, redirect?: string, notification?: string) => {
  return {
    type: requestActions.UNAUTHED_REQUEST,
    method: 'POST',
    url: `${API_URL}/${JWT_AUTH_ENDPOINT}`,
    successAction: success(API_SESSION_JWT_AUTH_CREATE),
    failureAction: failure(API_SESSION_JWT_AUTH_CREATE),
    body: { data },
    redirect,
    notification
  }
}

export const fetchSessionInfo = () => ({
  type: API_SESSION_FETCH
})

export const logoutUser = () => {
  return { type: LOGOUT_USER }
}

export const cleanStoreState = () => ({
  type: CLEAN_STORE_STATE
})

export const expireSession = (message = 'Your session has expired. Please login again.') => ({
  type: AUTH_EXPIRE_SESSION,
  message,
})

export const initializeLogin = () => ({
  type: INITIALIZE_LOGIN
})

export const updateClientSettings = ({
  key,
  value,
}: ClientSetting) => ({
  type: API_SESSION_CLIENT_SETTINGS_UPDATE,
  payload: {
    key,
    value,
  },
})

export const setLocalClientSettings = ({
  key,
  value,
}: {
  key: string;
  value: unknown;
}) => ({
  type: SET_LOCAL_CLIENT_SETTINGS,
  payload: { key, value },
})

export const queueClientSettingsUpdate = ({
  key,
  value,
}: {
  key: string;
  value: unknown;
}) => ({
  type: QUEUE_CLIENT_SETTINGS_UPDATE,
  payload: { key, value },
})

export const refreshSession = () => ({
  type: API_SESSION_REFRESH
})

export const scheduleSessionRefresh = (refreshAtMs: number, scheduledAtMs: number) => ({
  type: AUTH_SESSION_REFRESH_SCHEDULED,
  payload: {
    refreshAtMs,
    scheduledAtMs,
  }
})
